import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 8L12 2L10.59 0.59L6 5.17L1.41 0.589999L5.24537e-07 2L6 8Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
